import React from "react";
import "./VisionMissionSection.css";
import visionIcon from "../assets/vision-icon.png";
import missionIcon from "../assets/mission-icon.png";

const VisionMissionSection = () => {
  return (
    <div className="vision-mission-section">
      <div className="vision-mission-box">
        <h2 className="section-title">Vision & Mission That Drive Us</h2>

       <div className="vision-mission-content">
  {/* Vision */}
  <div className="vm-item">
    <div className="vm-icon">
      <img src={visionIcon} alt="Vision Icon" />
    </div>
    <div className="vm-text">
      <h3>Our Vision</h3>
      <p>
        To become a trusted car care and detailing company and professional car spa and auto detailing experts, leading the way in touchless car wash systems by making automated, eco-friendly vehicle care accessible to every corner of India.
      </p>
    </div>
  </div>

  {/* Mission */}
  <div className="vm-item">
    <div className="vm-icon">
      <img src={missionIcon} alt="Mission Icon" />
    </div>
    <div className="vm-text">
      <h3>Our Mission</h3>
      <p>
        As a trusted car care and detailing company and professional car spa and auto detailing experts, our mission is to build a smart and efficient car wash infrastructure across India with high-speed, eco-friendly solutions that deliver consistent, high-quality service—empowering both consumers and entrepreneurs in car care.
      </p>
    </div>
  </div>
</div>
      </div>
    </div>
  );
};

export default VisionMissionSection;
